import { cn } from '@/lib/cn.ts'
import { SpriteIcon } from './sprite-icon.tsx'

export const informationSymbols = [
  <symbol key='icon-information' id='icon-information' viewBox='0 0 12 12'>
    <path
      d='M6 0C9.31 0 12 2.69 12 6C12 9.31 9.31 12 6 12C2.69 12 0 9.31 0 6C0 2.69 2.69 0 6 0ZM6 1.2C3.35 1.2 1.2 3.35 1.2 6C1.2 8.65 3.35 10.8 6 10.8C8.65 10.8 10.8 8.65 10.8 6C10.8 3.35 8.65 1.2 6 1.2ZM6 5.4C6.33 5.4 6.6 5.67 6.6 6V7.8H7.5V9H4.5V7.8H5.4V6.6H4.5V5.4H6ZM5.85 3C6.26 3 6.6 3.34 6.6 3.75C6.6 4.16 6.26 4.5 5.85 4.5C5.44 4.5 5.1 4.16 5.1 3.75C5.1 3.34 5.44 3 5.85 3Z'
      fill='currentColor'
    />
  </symbol>
]

export function InformationIcon ({ className }: { className?: string }): JSX.Element {
  return <SpriteIcon id='icon-information' size={12} className={cn('size-3', className)} />
}
